/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

class Confirmation extends React.Component {
	componentDidMount() {
		document.querySelector('#sticky .col-md-10').style.display = 'none'
		document.querySelector('#sticky .col-md-2').style.display = 'none'
	}
	render() {
		let shoppingCartItems = [
			{
				title: 'Print Ethno Tank',
				sku: '7165370020001',
				price: 59.99,
				color: 'black',
				size: 'small',
				quantity: 2,
				image: 'https://placehold.it/150'
			},
			{
				title: 'Twill Summer Floral Shorts',
				sku: '7165370020001',
				price: 29.99,
				color: 'pink',
				size: 'medium',
				quantity: 1,
				image: 'https://placehold.it/150'
			},
			{
				title: 'Wave Gloss Purse',
				sku: '7165370020001',
				price: 129.99,
				color: 'black mix',
				size: 'one size',
				quantity: 1,
				image: 'https://placehold.it/150'
			}
		]
		let arrLastIndex = shoppingCartItems.length - 1

		let subtotal = 0
		subtotal = shoppingCartItems.map((item, i) => {
			subtotal += item.quantity * item.price

			if (arrLastIndex === i) {
				return subtotal.toFixed(2)
			}

			return 0
		})

		let discount = (parseFloat(subtotal[arrLastIndex]) * 0.1).toFixed(2)
		let taxes = (parseFloat(subtotal[arrLastIndex]) * 0.08125).toFixed(2)

		return (
			<div className='main-container'>
				<Section id='confirm-header__section'>
					<div className='col-md-6 offset-md-3 col-12 offset-0 text-center'>
						<h3 className=''>Please Review Your Order</h3>
						<p>
							Let's just confirm the all the information we've got
							is correct!
						</p>
					</div>
				</Section>
				<section id='process-stepper__section'>
					<div className='container'>
						<div className='row justify-content-center'>
							<div className='col-12'>
								<div className='row justify-content-center'>
									<span className='process-list__item col-md-3 col-12'>
										<h4 className='text-center'>
											<a href='/shipping'>
												Shipping Info
											</a>
										</h4>
									</span>
									<span className='process-list__item col-md-3 col-12'>
										<span className='process-list__middot' />
										<h4 className=' text-center'>
											<a href='/payment'>Payment</a>
										</h4>
										<span className='process-list__middot' />
									</span>
									<span className='process-list__item col-md-3 col-12'>
										<h4 className='text-center'>
											<a href='/confirmation'>
												Confirmation
											</a>
											<hr />
										</h4>
									</span>
								</div>
							</div>
						</div>
					</div>
				</section>

				<Section id='order-details__section'>
					<div className='col-12'>
						<h3>Order Details</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						{shoppingCartItems.map((item, i) => {
							return (
								<div className='row cart-item' key={i}>
									<div className='col-md-3'>
										<img
											src={item.image}
											alt='placeholder'
										/>
									</div>
									<div className='col-md-6'>
										<h4 className='semi-'>{item.title}</h4>
										<p className='semi-'>#{item.sku}</p>
										<div className='item-info'>
											<span className='item-info__detail'>
												<FAI icon='tint' />
												&ensp;
												{item.color}
											</span>
											<span className='item-info__detail'>
												<FAI icon='tshirt' />
												&ensp;
												{item.size}
											</span>
											<span className='item-info__detail'>
												<FAI icon='shopping-bag' />
												&ensp;
												{item.quantity}
											</span>
										</div>
									</div>
									<div className='col-md-3 text-right'>
										<h4>${item.quantity * item.price}</h4>
									</div>
								</div>
							)
						})}
					</div>
				</Section>

				<Section id='estimation__section'>
					<div className='col-12'>
						<h3>Estimation</h3>
					</div>
					<div className='col-md-4'>{/* spacing columnt */}</div>
					<div className='col-md-8'>
						<ul>
							<li>
								<h4 className='text--muted'>Order</h4>
								<span className='estimate-price '>
									{`$${subtotal[arrLastIndex]}`}
								</span>
							</li>
							<li>
								<h4 className='text--muted'>Shipping</h4>
								<span className='estimate-price '>$7.00</span>
							</li>
							<li>
								<h4 className='text--muted'>Bonus/Discount</h4>
								<span className='estimate-price '>
									{`-$${discount}`}
								</span>
							</li>
							<li>
								<h4 className='text--muted'>Taxes</h4>
								<span className='estimate-price '>
									{`$${taxes}`}
								</span>
							</li>
							<li>
								<h4 className='text--muted'>Total</h4>
								<span className='estimate-price '>
									{`$${parseFloat(
										subtotal[arrLastIndex] -
											discount +
											taxes
									).toFixed(2)}`}
								</span>
							</li>
						</ul>
						<h4>Have a Discount Code?</h4>
						<div className='row'>
							<div className='col-12'>
								<form action='#'>
									<div className='row'>
										<div className='col-md-4'>
											<input
												type='text'
												name='discountCode'
												id='discount-code'
												pattern='(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}'
												placeholder='XXX-XXX'
											/>
										</div>
										<div className='col-md-4'>
											<button
												className='btn'
												type='submit'>
												<span className='btn__text'>
													Apply Coupon
												</span>
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</Section>

				<Section id='customer-info__section'>
					<div className='col-12'>
						<h3>
							Customer
							<br />
							Information
						</h3>
					</div>
					<div className='col-md-4'>{/* spacing column */}</div>
					<div className='col-md-8'>
						<div className='row'>
							<div className='col-md-6'>
								<h4 className='semi-'>Shipping Address</h4>
								<ul>
									<li>Marcela Garcia</li>
									<li>123 Main St.</li>
									<li>Beverly Hills</li>
									<li>California</li>
									<li>90210</li>
									<li>(310) 285-4950</li>
								</ul>
							</div>
							<div className='col-md-6'>
								<h4 className='semi-'>Billing Address</h4>
								<ul>
									<li>Marcela Garcia</li>
									<li>123 Main St.</li>
									<li>Beverly Hills</li>
									<li>California</li>
									<li>90210</li>
									<li>(310) 285-4950</li>
								</ul>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<h4 className='semi-'>Shipping Method</h4>
								<ul>
									<li>Standard (3-5 Business Days)</li>
								</ul>
							</div>
							<div className='col-md-6'>
								<h4 className='semi-'>Payment Method</h4>
								<ul>
									<li>Credit Card ***0987</li>
								</ul>
							</div>
						</div>
					</div>
				</Section>

				<Section id='proceed__section'>
					<div className='col-12 text-right'>
						<a href='/thank-you' className='btn btn--primary'>
							<span className='btn__text'>Confirm Order</span>
						</a>
					</div>
				</Section>
			</div>
		)
	}
}

export default Confirmation
